module.exports = __webpack_public_path__ + "img/doski-i-aksessuary-k-nim.ea263f1f.svg";